// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__1jV3C"};